import React from 'react';
import Chart from 'react-apexcharts';
import { Loader, Panel, Stack } from 'rsuite';

interface BarChartProps {
  title?: React.ReactNode;
  actions?: React.ReactNode;
  data: any;
  type?:"area" | "line" | "bar" | "pie" | "donut" | "radialBar" | "scatter" | "bubble" | "heatmap" | "treemap" | "boxPlot" | "candlestick" | "radar" | "polarArea" | "rangeBar" | "rangeArea" | undefined;
  options?: any;
  labels?: string[];
  loading?: boolean;
}

const defaultOptions = {
  chart: {
    fontFamily: 'inherit',
    parentHeightOffset: 0,
    toolbar: {
      show: false
    },
    animations: {
      enabled: false
    },
    stacked: true
  },
  plotOptions: {
    bar: {
      columnWidth: '50%'
    }
  },
  dataLabels: {
    enabled: false
  },
  fill: {
    opacity: 1
  },
  grid: {
    padding: {
      top: -20,
      right: 0,
      left: -4,
      bottom: -4
    },
    strokeDashArray: 4,
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  xaxis: {
    tooltip: {
      enabled: false
    },
    axisBorder: {
      show: false
    },
    type: 'datetime'
  },
  yaxis: {
    labels: {
      padding: 4
    }
  },
  colors: ['#206bc4', '#79a6dc', '#bfe399'],
  legend: {
    show: false
  }
};

const BarChart = ({ title, actions, data, type, labels, options, loading }: BarChartProps) => (
  <Panel
    className="card"
    header={
      <Stack justifyContent="space-between">
        {title}
        {actions}
      </Stack>
    }
  >
    <div style={{ position: "relative" }}>
      <Chart
        series={data}
        type={type}
        height={284}
        options={Object.assign({}, defaultOptions, options, { labels })}
      />
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,255,255,0.6)",
            backdropFilter: "blur(2px)", // optional blur effect
            zIndex: 10,
          }}
        >
          <Loader size="sm" />
        </div>
      )}      
    </div>
  </Panel>
);

export default BarChart;
